// extracted by mini-css-extract-plugin
export default {"root":"NewClient_root__LIZhn","heading":"NewClient_heading__E2KmK","submit":"NewClient_submit__p5Sv2"};